import Header from "./components/Header";
import Footer from "./components/footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Home from "./pages/home";
import Products from "./pages/products";
import FAQ from "./pages/faq";
import Contact from "./pages/contact";
import "./index.css";

export default function App() {
	const headerRef = useRef<HTMLDivElement | null>(null);
	const headerCompanyRef = useRef<HTMLDivElement | null>(null);
	const [menuOpen, setMenuOpen] = useState(false);

	const [topOffset, setTopOffset] = useState<number>(0);
	const updateOffset = () => {
		if (headerRef.current && headerCompanyRef.current) {
			const height = headerRef.current.offsetHeight;
			setTopOffset(-height / 1.4);
			headerCompanyRef.current.style.height = `${height * 0.3}px`; // Set matching height
		}
	};

	useEffect(() => {
		requestAnimationFrame(() => {
			updateOffset();
		});
		window.addEventListener("resize", updateOffset);
		return () => window.removeEventListener("resize", updateOffset);
	}, []);

	return (
		<div className={`app-container ${true ? "authorized" : "unauthorized"}`}>
			<div className="header-company-name-container" ref={headerCompanyRef}>
				<div
					className={`header-company-name ${menuOpen ? "hidden" : ""}`}
					onClick={() => {
						window.location.href = "/";
					}}
				>
					Heron Lane Farm
				</div>
				<button
					className={menuOpen ? "hamburger hamburger-active" : "hamburger"}
					onClick={() => setMenuOpen(!menuOpen)}
					aria-label="Toggle menu"
				>
					☰
				</button>
			</div>
			<div
				ref={headerRef}
				className={`header-container ${menuOpen ? "masked" : ""}`}
				style={{ top: `${menuOpen ? 0 : topOffset}px` }}
				onLoad={updateOffset}
			>
				<Header menuOpen={menuOpen} />
			</div>
			<div className={`main-content ${menuOpen ? "hidden" : ""}`}>
				<Router>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/products" element={<Products />} />
						<Route path="/faq" element={<FAQ />} />
						<Route path="/contact" element={<Contact />} />
					</Routes>
				</Router>
			</div>
			<div className="footer-container">
				<Footer />
			</div>
		</div>
	);
}
